import { WidgetPlugin } from './types';

export class PluginRegistry {
  private plugins: WidgetPlugin[] = [];

  register<T>(plugin: WidgetPlugin<T>) {
    this.plugins.push(plugin as WidgetPlugin);
  }

  getPlugin<T>(type: string, template: string): WidgetPlugin<T> | undefined {
    return this.plugins.find(
      plugin => plugin.type === type && plugin.template === template,
    ) as WidgetPlugin<T>;
  }
}

export const pluginRegistry = new PluginRegistry();
